export enum ActionReasonEnum {
  Cancel = 'Cancel',
  Revert = 'Revert',
  MissingItems = 'MissingItems',
  Leave = "Leave",
  EditTimeWindow = "EditTimeWindow"
}
